import { useEffect, useState } from 'react'
import { logo, logoInverse } from '../assets'
import { THEME_EVENT, getResolvedTheme } from '../utility/theme'

/* ============================================================================
   The wordmark is navy pixels inside a PNG, not text, so CSS cannot recolour
   it - the only way to keep it readable in both modes is to swap the file.
   Everything that renders the logo goes through here so that decision is made
   once, and follows a live mode change rather than only the initial paint.
   ========================================================================== */
const Logo = (props) => {
  const [resolved, setResolved] = useState(getResolvedTheme)

  useEffect(() => {
    const onThemeChange = (e) => setResolved(e.detail.resolved)
    window.addEventListener(THEME_EVENT, onThemeChange)
    return () => window.removeEventListener(THEME_EVENT, onThemeChange)
  }, [])

  return (
    <img alt="Rapidsofts" {...props} src={resolved === 'dark' ? logoInverse : logo} />
  )
}

export default Logo
